<div class="relative">
  <label [for]="inputId" class="sb_floating_label mb-1">
    <strong>{{ label }}</strong>
    @if (required) {
      <span class="text-red-500">*</span>
    }
    @if (calculated) {
      <span class="badge-calc">Calculated</span>
    }
  </label>
  <input
    type="text"
    trimInput
    class="form-control"
    autocomplete="off"
    [id]="inputId"
    [placeholder]="placeholder"
    [readonly]="readonly || calculated"
    [value]="value"
    (mousedown)="$event.stopPropagation()"
    (focus)="onFocus()"
    (input)="onInput($event.target.value)"
  />

  @if (isFocused) {
    <div
      class="floating-suggestion show"
      #floatingSuggestionRef
      (mousedown)="$event.stopPropagation()"
    >
      <div class="suggestion-header">PREETI OUTPUT</div>
      <div class="suggestion-body">{{ floatingSuggestion }}</div>
      <div class="suggestion-footer">
        <button type="button" class="sb_btn primary_button" (click)="patchValue()">
          Patch
        </button>
      </div>
    </div>
  }
</div>

